export const auth = {
  field: {
    email: 'E-mail address',
    password: 'Password',
    remember_me: 'Remember Me'
  },

  button: {
    recovery_password: 'Forgot your password?\n',
    create_account: 'Create an account',
    no_acc: "Don't have an account?",
    sign_up: 'Sign up',
    sign_in: 'Sign in',
    log_in: 'Log in'
  },
  message:
    'The section on the site is being updated and will appear later. To register, please contact our support team',
  phone: 'Phone'
};
